/*
 *
 * Estas librerias estan presentes tanto en la website como en el dashboard
 *
 */

//Librerias necesarias
import VeeValidate, { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es';
import Datetime from 'vue-datetime';
import vSelect from 'vue-select';
import vueTopprogress from 'vue-top-progress';
// import '@fortawesome/fontawesome-free/js/all.js';
import Vue2Editor from "vue2-editor";
import SweetModal from 'sweet-modal-vue/src/plugin.js';


import * as VueGoogleMaps from 'vue2-google-maps';

import DisableAutocomplete from 'vue-disable-autocomplete';




//Funcion para añadirlas a Vue
function fire(Vue){
	//Vee-validate
	Validator.localize('es', es);
	Vue.use(VeeValidate,{locale:"es"});
	//vue-datetime
	Vue.use(Datetime);
	//Vue-select
	Vue.component('v-select', vSelect);
	//Loading bar
	Vue.use(vueTopprogress);
	//vue2Editor
	Vue.use(Vue2Editor);
	Vue.use(SweetModal);

	Vue.use(VueGoogleMaps, {
	 	load: {
	 		key: 'AIzaSyC6_hC3Rwth69RqXpO0_ykbgovt94Dp2f4',


			libraries: 'places', // This is required if you use the Autocomplete plugin
					// OR: libraries: 'places,drawing'
					// OR: libraries: 'places,drawing,visualization'
					// (as you require)
		},
		installComponents: true,
	});

	Vue.use(DisableAutocomplete);

}



// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default fire;
